import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


export const getjxcList = (params) => {
  return axios.post(root + '/set/jxcforms/list', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/jxcforms/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/set/jxcforms/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
    return axios.post(root + '/set/jxcforms/saveAllocation', qs.stringify(params))
}

//保存某一行的数据
export const saveAllocationStore = (params) => {
  return axios.post(root + '/set/jxcforms/saveAllocationStore', qs.stringify(params))
}

//修改状态确认收货
export const  receiveAllocation= (params) => {
  return axios.post(root + '/set/jxcforms/receiveAllocation', qs.stringify(params))
}




// WEBPACK FOOTER //
// ./src/api/set/allocation.js